import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AccountService } from 'src/app/services/account.service';
import { LanguageService } from 'src/app/services/language.service';
/** Displays menu elements */

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent implements OnInit {

  componentUrl: boolean = false;
  recalledUrl: boolean = false;
  bikeConfigurationUrl: boolean = false;
  softwareOverviewUrl: boolean = false;
  bikeOverviewUrl: boolean = false;

  constructor(public languageService: LanguageService, private accountService: AccountService, private router: Router) {
  }

  ngOnInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.componentUrl = document.URL.includes("component-variant");
        this.recalledUrl = document.URL.includes("recalled-upload");
        this.bikeConfigurationUrl = document.URL.includes("view-configuration");
        this.softwareOverviewUrl = document.URL.includes("start-approval-rollout") || document.URL.includes("start-rollout")
          || document.URL.includes("view-software") || document.URL.includes("edit-software") || document.URL.includes("monitor-software");
        this.bikeOverviewUrl = document.URL.includes("bike-details");
      }
    });
  }

  public hasComponentViewRole(): boolean {
    return this.accountService.hasComponentViewRole();
  }

  public hasComponentSupportRole(): boolean {
    return this.accountService.hasComponentSupportRole();
  }

  public hasConfigurationViewRole(): boolean {
    return this.accountService.hasConfigurationViewRole();
  }

  public hasConfigurationModifyRole(): boolean {
    return this.accountService.hasConfigurationModifyRole();
  }

  public hasSoftwareViewRole(): boolean {
    return this.accountService.hasSoftwareViewRole();
  }

  public hasSoftwareModifyRole(): boolean {
    return this.accountService.hasSoftwareModifyRole();
  }

  public hasBikeViewRole(): boolean {
    return this.accountService.hasBikeViewRole();
  }

  public hasUnassignedBikesViewRole(): boolean{
    return this.accountService.hasUnassignedBikesViewRole();
  }

  public hasBikeUnmapRole(): boolean {
    return this.accountService.hasBikeUnmapRole();
  }

  public hasValidOEM(): boolean{
    return this.accountService.hasValidOEM();
  }
}
